import { render, staticRenderFns } from "./AdUnit.vue?vue&type=template&id=af6faafe&scoped=true"
import script from "./AdUnit.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdUnit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdUnit.vue?vue&type=style&index=0&id=af6faafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6faafe",
  null
  
)

export default component.exports